export default {
  days: `[
    "Ahad",
    "Senin",
    "Selasa",
    "Rabu",
    "Kamis",
    "Jumat",
    "Sabtu"
  ]`,
  daysShort: `[
    "Ahd",
    "Snn",
    "Sls",
    "Rbu",
    "Kms",
    "Jum",
    "Sbt"
  ]`,
  months: `[
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember"
  ]`,
  monthsShort: `[
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Agu",
    "Sep",
    "Okt",
    "Nov",
    "Des"
  ]`
}
